import { useMutation } from "@apollo/client/react";
import { CREATE_MONITOR_EVENT_COMMENT } from "../../mutations/aml/createMonitorEventComment";

export const useCreateMonitorEventComment = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: (error: any) => void;
}) => {
  const [createMonitorEventComment, { data, loading, error }] =
    useMutation<String>(CREATE_MONITOR_EVENT_COMMENT, {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [],
      awaitRefetchQueries: true,
    });

  return { createMonitorEventComment, data, loading, error };
};
